import PropTypes from "prop-types";
import { memo, useCallback } from "react";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import { FormattedMessage } from "react-intl";
import get from "lodash/get";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import RadioFormik from "app/pages/.shared/form/RadioFormik";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { ArrowRightIcon } from "app/icons/navigation";

const DepartureCity = ({
	onChange,
	departureCity,
	amountSuffix,
	productInfo,
	showCTA,
	...props
}) => {
	const handleChange = useCallback(() => {
		onChange(departureCity);
	}, [departureCity]);

	return (
		<RadioFormik
			id={`departureCity-${departureCity.code}`}
			name="departureCity"
			value={departureCity.code}
			toggle={handleChange}
			data-testid={props["data-testid"]}
		>
			<div className="departure-city__content">
				<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
					<div className="departure-city__label">
						<span>{departureCity.label}</span>
						{productInfo.ul === true && (
							<div className="departure-city__info">
								<FormattedMessage id="search.engine.departure.city.info.business.flight" />
							</div>
						)}
					</div>
				</Typography>
				<div className="departure-city__price">
					<AmountContainer
						amount={get(departureCity, "from.p")}
						prefix={<FormattedMessage id="offer.per.person.from.label" />}
						suffix={amountSuffix}
					/>
					{showCTA && (
						<div className="departure-city__cta">
							<Button
								variant={BUTTON_VARIANTS.FILLED}
								size={BUTTON_SIZES.SMALL}
								icon={<ArrowRightIcon />}
							/>
						</div>
					)}
				</div>
			</div>
		</RadioFormik>
	);
};

DepartureCity.defaultProps = {
	field: {},
	departureCity: {},
	productInfo: {},
};

DepartureCity.propTypes = {
	productInfo: PropTypes.object,
	departureCity: PropTypes.object,
	amountSuffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	field: PropTypes.object,
	onChange: PropTypes.func,
	showCTA: PropTypes.bool,
	"data-testid": PropTypes.string,
};

export default memo(DepartureCity);
